
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/looks/[id]/[[...slug]]",
      function () {
        return require("private-next-pages/looks/[id]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/looks/[id]/[[...slug]]"])
      });
    }
  